import { Box, Checkbox, Typography } from "@mui/material";
import useInventoryNotes from "src/hooks/debt/useInventoryNotes";
import { v4 as uuid } from "uuid";
import { CONTEXT_TYPE, TYPE } from "../const/constants";
import usePreviewPdf from "./usePreviewPdf";
import ViewBtn from "src/components/shared/ViewBtn";
import useAppGlobal from "src/context/useAppGlobal";
import DebtDetailDialog from "../DebtWarehouse/Dialogs/DebtDetailDialog";
import { useState } from "react";

const EXPORT_TYPE = {
  OrderReturn: "Xuất bỏ hàng hoàn",
  Manual: "Xuất bỏ thủ công",
};

export default function useDebtWarehouseRemovedTab({ date, keyWord, filter }) {
  const [pagi, setPagi] = useState({limit: 50, skip: 0})
  const { handleOpenDialog } = useAppGlobal();

  const { data } = useInventoryNotes({
    ...pagi,
    ...filter,
    contextType: CONTEXT_TYPE.REMOVE,
    type: TYPE.OUTBOUND,
    fromDate: date?.fromDate ?? undefined,
    toDate: date?.toDate ?? undefined,
    searchField: "code",
    searchValue: keyWord ?? undefined,
  });

  const { onPrintWarehouseTransfer } = usePreviewPdf();

  const handleInnCodeView = (item) => {
    handleOpenDialog({
      title: "Chi tiết xuất bỏ",
      content: <DebtDetailDialog item={item} />,
      size: "md",
    });
  };

  let bodyList = data?.data?.map((item, index) => ({
    ...item,
    no: index + 1,
    checkbox: <Checkbox checked={item.checked} />,
    exportTicket: (
      <Typography
        sx={{ color: "primary", textDecoration: "underline", cursor: "pointer" }}
        onClick={() => onPrintWarehouseTransfer(item)}
      >
        {item?.code ?? "-"}
      </Typography>
    ),
    exportType: (
      <>
        <Typography fontWeight="bold">{item?.exportType ? EXPORT_TYPE[item?.exportType] : "-"}</Typography>
      </>
    ),
    exportWarehouse: <Typography>{item?.warehouse?.name}</Typography>,
    reason: <Typography>{item?.reason ?? "-"}</Typography>,
    staff: <Typography>{item?.exportBy?.fullName ?? "-"}</Typography>,
    action: (
      <Box
        display="flex"
        gap={1}
        justifyContent="center"
      >
        <ViewBtn handleView={() => handleInnCodeView(item)} />
        {/* <PrintBtn /> */}
      </Box>
    ),
  }));

  let header = [
    {
      id: uuid(),
      title: <Checkbox />,
      align: "center",
    },
    {
      id: uuid(),
      title: "STT",
      align: "center",
    },
    {
      id: uuid(),
      title: "Phiếu xuất",
      align: "center",
    },
    {
      id: uuid(),
      title: "Kho xuất",
      align: "center",
    },
    {
      id: uuid(),
      title: "Hình thức xuất bỏ",
      align: "center",
    },
    {
      id: uuid(),
      title: "Nhân viên xuất bỏ",
      align: "center",
    },
    {
      id: uuid(),
      title: "Lý do xuất bỏ",
      align: "center",
    },
    {
      id: uuid(),
      title: "Thao tác",
      align: "center",
    },
  ];

  const sortData = ["checkbox", "no", "exportTicket", "exportWarehouse", "exportType", "staff", "reason", "action"];

  const totalDiscardedValue = data?.data?.reduce((sum, item) => sum + (item?.total ?? 0), 0);

  return { bodyList, header, pagi, setPagi, total: data?.count ?? 0, sortData, totalDiscardedValue };
}
